
import { Badge, Icon, Popup } from '@scuf/common';
import React, { useEffect, useRef, useState } from 'react';
import { useActionItems, useCount } from 'src/hooks/pendingActions';
import { useNavigate } from 'react-router-dom';
import { RouteConstants, USER_ROLE, VIEW_TYPE } from 'src/constants/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setOverviewViewType } from 'src/slices/overviewSlice';
import { addDashboardFilter, getallOpportunities, setViewType } from 'src/slices/allOpportunitySlice';
import { getCurrentRole, getOnBoardingAPIData } from 'src/slices/onBoardingSlice';
import { getActionStatus } from 'src/slices/opportunitySlice';

export const  Flag = ({closeAllOtherPopup}:any) =>  {
    const navigate = useNavigate();
    const actionStatus = useSelector(getActionStatus);
    const userOnboardStatus = useSelector(getOnBoardingAPIData);
    const currentRole = useSelector(getCurrentRole);
    const {total_count} = useCount(currentRole,userOnboardStatus?.roles, actionStatus);
    const actions = useActionItems(currentRole,userOnboardStatus?.roles, actionStatus);
    
    let pendingRef: any = useRef();
    const dispatch = useDispatch();
    const [showPending, setPendingTaskPopup] = useState(false);

    useEffect(()=> {
      const handleClickOutside = (event: any) => {
        if (pendingRef.current && !pendingRef.current.contains(event.target)) {
          setPendingTaskPopup(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside, true);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside, true);
      };
    })
  

    const navigateTo = (id: string) => {
      setPendingTaskPopup(false);
      navigate(`${RouteConstants.ANOMALY_DETAILS_RELATIVE_PATH}/${id}`)
    }

    const fetchAnomalies = () => {
        setPendingTaskPopup(false);
        dispatch(addDashboardFilter([]));
        dispatch(setOverviewViewType(VIEW_TYPE.PENDING_ACTIONS));
        dispatch(setViewType(VIEW_TYPE.PENDING_ACTIONS))
        dispatch(getallOpportunities());
        navigate(RouteConstants.ANOMALY_ABSOLUTE_PATH);
    }

    const hasPermission = () => (
      userOnboardStatus?.roles?.includes(USER_ROLE.VIEWER) ||
      userOnboardStatus?.roles?.includes(USER_ROLE.REVIEWER) ||
      userOnboardStatus?.roles?.includes(USER_ROLE.DOMAIN_FOCAL) ||
      userOnboardStatus?.roles?.includes(USER_ROLE.LEADERSHIP_USER) ||
      userOnboardStatus?.roles?.includes(USER_ROLE.POWER_USER) ||
      userOnboardStatus?.roles?.includes(USER_ROLE.ADMIN_USER) 
    )

    const toggleDropdown = () => {
      if (!hasPermission()) {
        return;
      }
      setPendingTaskPopup(!showPending);
      closeAllOtherPopup();
    }
    return (
        <Popup
        open={showPending}
        className="feedback-new pending"
        element={
          <div
            onClick={toggleDropdown}
            data-testid="feedback-popup-1 pending-icon-flag "
            className={`fi-header__items__anytime-feedback ${showPending ? 'fi-header__items__anytime-feedback--selected' : ''}`}
          >
            <Icon root="common" name="flag" size="medium" className='flag-icon'/>
            { total_count !== 0 && <Badge color="red" className='pending-count'>{total_count}</Badge>}
          </div>
        }
        offset='-8, 0'
        position="bottom right">
        <div
          ref={pendingRef}
        >
            <div>
            {actions?.metadata?.total_row_count > 3 && <div className="view_all"><a  onClick={() => { fetchAnomalies()}}>View All Actions</a></div>}
              <ul  className='pending-actions' >
                {actions?.opportunity_detail?.map ((item, index) => <li key={index} onClick={() => navigateTo(item.insight_id)}>Anomaly ID: <span>{item.insight_id}</span> {item.insight_summary_display_category}</li>)}
                {actions?.length == 0 && <li>No action assigned for now. </li>}
              </ul>
            </div>
        </div>
      </Popup>
    )
}